<template>
  <item-nav :id="$attrs['id']">
    <item-nav-group v-if="!isEmpty(folios)" :open="true" :label="$t(`folio.title.${folios.parent.type}`, [folios.parent.reservationNumber || folios.parent.guestProfileNumber])">
      <item-nav-group-item :params="this.$route.prams" :link="`${$route.meta.parent}Folios`" :label="$t('layout.nav.folioNav.overview')" />
      <item-nav-group-item v-for="folio in folios.folios"
                           :label="folio.name"
                           :params="routeParams(folio.id)"
                           :key="folio.id"
                           :class="[{ 'item-nav__li--drop': folio.id === dropTarget }]"
                           :link="`${$route.meta.parent}Folio`"
                           @dragenter="dragenter($event, folio)"
                           @dragleave="dragleave($event, folio)"
                           @dragover="dragover($event, folio)"
                           @drop="drop($event, folio)">
        <!--        <template slot="label">{{ folio.name }} <i v-if="folio.noPost && isEmpty(folio.invoiceNumber)" style="padding-left:0.75rem;" class="fal fa-lock"></i> <i v-if="(folio.hasAnyTransactions === true && folio.status !== 'Final') || folio.balance !== 0" style="padding-left:0.75rem;" class="fal fa-exclamation-triangle color&#45;&#45;warn"></i></template>-->
        <template slot="label">{{ folio.name }} <i v-if="folio.noPost && isEmpty(folio.invoiceNumber)" style="padding-left:0.75rem;" class="fal fa-lock"></i></template>
      </item-nav-group-item>
    </item-nav-group>
    <!--
    <item-nav-group v-for="wrapper in additionalFolios" :open="true"
                    :label="wrapper.data.parent.name || $t(`folio.title.${wrapper.data.parent.type}`, [wrapper.data.parent.reservationNumber || wrapper.data.parent.guestProfileNumber])">
      <item-nav-group-item v-for="folio in wrapper.data.folios" :label="folio.name" :params="routeParamsAdditional(wrapper.parentId, folio.id)" :key="folio.id" link="home"/>
    </item-nav-group>
    -->

    <transfer-overlay :dark-mode="true" />
  </item-nav>
</template>

<script>

import { cloneDeep, isNil, isEmpty } from 'lodash';
import ItemNavGroup from './ItemNavGroup';
import ItemNavGroupItem from './ItemNavGroupItem';
import HotelmeisterMixin from '../../../../mixins/HotelmeisterMixin';

export default {
  name: 'FolioNav',
  components: { ItemNavGroupItem, ItemNavGroup },

  mixins: [HotelmeisterMixin],
  props: [],

  data() {
    return {
      folios: {},
      additionalFolios: [],
      dropTarget: null,
    };
  },

  computed: {
    parentId: function () {
      return this.$route.params.reservationId || this.$route.params.guestProfileId;
    },
  },

  created: function () {
    this.$serviceBus.$on('folio.list', (data) => {
      this.folios = data.data;
    });
    this.$serviceBus.$on('additionalFolio.list', (data) => {
      this.additionalFolios.push(data);
    });
  },

  mounted: function () {
    this.$emit('widenav', true);
  },

  methods: {
    dragleave($event, folio) {
      if (this.dropTarget === folio.id) {
        this.dropTarget = null;
        this.$serviceBus.$emit('transaction.dragleave');
        $event.dataTransfer.dropEffect = 'none';
      }
      $event.stopPropagation();
    },
    drop($event, folio) {
      this.dropTarget = null;
      const srcTransaction = JSON.parse($event.dataTransfer.getData('text/plain'));
      if (!isEmpty(srcTransaction.transactionId) && !isEmpty(srcTransaction.parentId) && !isEmpty(srcTransaction.folioId)) {
        if (srcTransaction.folioId === folio.id && srcTransaction.parentId === this.parentId) {
          this.showSuccessMessage();
          return;
        }

        if (this.$store.getters['save/saveInProgress']) return;

        this.$store.commit('save/started', this.$route.params.folioId);
        this.axios.put(this.serviceUrls.folio.transferTransaction(this, srcTransaction.parentId, srcTransaction.folioId, srcTransaction.transactionId), { parentId: this.parentId, folioId: folio.id })
          .then((response) => {
            this.$serviceBus.$emit('folio.reload');
            this.showSuccessMessage();
          })
          .catch((error) => {
            this.showMessages(error.response);
          })
          .finally(() => {
            this.$store.commit('save/finished', this.$route.params.folioId);
          });
      }
    },
    dragover($event, folio) {
      if (isEmpty(folio.invoiceNumber) && folio.locked !== true) {
        $event.dataTransfer.dropEffect = 'move';
      } else {
        $event.dataTransfer.dropEffect = 'none';
      }
      $event.preventDefault();
      $event.stopPropagation();
    },
    dragenter($event, folio) {
      if (isEmpty(folio.invoiceNumber) && folio.locked !== true) {
        $event.dataTransfer.dropEffect = 'move';
        this.dropTarget = folio.id;
        this.$serviceBus.$emit('transaction.dragenter');
      } else {
        $event.dataTransfer.dropEffect = 'none';
      }
      $event.preventDefault();
      $event.stopPropagation();
    },
    routeParams(folioId) {
      const ret = cloneDeep(this.$route.params);
      ret.folioId = folioId;
      return ret;
    },
    routeParamsAdditional(parentId, folioId) {
      const ret = cloneDeep(this.$route.params);
      ret.folioId = folioId;
      ret.parentId = parentId;
      ret.reservationId = parentId;
      ret.guestProfileId = parentId;
      return ret;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  // @import '~styles/main';
</style>



// WEBPACK FOOTER //
// src/components/lib/layout/nav/FolioNav.vue